import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import shortid from 'shortid'
import get from 'lodash/get'
import set from 'lodash/set'
import orderBy from 'lodash/orderBy'
import ReactList from 'react-list'
import arrow_down from '../../static/images/arrow-down.svg'
import arrow_up from '../../static/images/arrow-up.svg'
import { inbox_table_header, FONTS, COLORS } from '../../constants'

export default class LeaveTypeTable extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (JSON.stringify(get(nextProps, 'myInbox')) !== JSON.stringify(prevState.myInbox)) {
      let list
      switch (prevState.sort_column) {
        case 0: {
          list = orderBy(get(nextProps, 'myInbox'), (item) => {
            const order = {
              'PENDING': 1,
              'PENDING_HR': 2,
              'APPROVED': 3,
              'CANCEL': 4,
              'REJECTED': 5,
            }
            return order[item.status]
          }, 'asc')
          break
        }
        case 1: {
          list = orderBy(get(nextProps, 'myInbox'), 'emp_code', 'asc')
          break
        }
        case 2: {
          list = orderBy(get(nextProps, 'myInbox'), 'default_start_date', 'asc')
          break
        }
        case 3: {
          list = orderBy(get(nextProps, 'myInbox'), 'lob', 'asc')
          break
        }
        case 4: {
          list = orderBy(get(nextProps, 'myInbox'), 'name', 'asc')
          break
        }
        case 5: {
          list = orderBy(get(nextProps, 'myInbox'), 'nick_name', 'asc')
          break
        }
        case 6: {
          list = orderBy(get(nextProps, 'myInbox'), 'position', 'asc')
          break
        }
        case 7: {
          list = orderBy(get(nextProps, 'myInbox'), 'leave_type', 'asc')
          break
        }
        case 8: {
          list = orderBy(get(nextProps, 'myInbox'), 'default_end_date', 'asc')
          break
        }
        default: break
      }
      set(tempState, 'myInbox', get(nextProps, 'myInbox'))
      set(tempState, 'items', [...list])
    }
    return tempState
  }

  state={
    sort_order: true,
    sort_column: 0,
    myInbox: [],
    items: [],
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props)
    && JSON.stringify(nextState) === JSON.stringify(this.state)) return false
    return true
  }

  handleClickSort = (column) => {
    let { sort_order } = { ...this.state }
    const { myInbox } = this.state

    if (column === this.state.sort_column) {
      sort_order = !this.state.sort_order
      this.setState({
        sort_order: !this.state.sort_order,
      })
    } else {
      sort_order = false
      this.setState({
        sort_order: false,
        sort_column: column,
      })
    }
    sort_order = sort_order ? 'asc' : 'desc'
    switch (column) {
      case 0: {
        const newItems = orderBy(myInbox, (item) => {
          const order = {
            'PENDING': 1,
            'PENDING_HR': 2,
            'APPROVED': 3,
            'CANCEL': 4,
            'REJECTED': 5,
          }
          return order[item.status]
        }, sort_order)
        return this.setState({ items: newItems })
      }
      case 1: {
        const newItems = orderBy(myInbox, 'emp_code', sort_order)
        return this.setState({ items: newItems })
      }
      case 2: {
        const newItems = orderBy(myInbox, 'default_start_date', sort_order)
        return this.setState({ items: newItems })
      }
      case 3: {
        const newItems = orderBy(myInbox, 'lob', sort_order)
        return this.setState({ items: newItems })
      }
      case 4: {
        const newItems = orderBy(myInbox, 'name', sort_order)
        return this.setState({ items: newItems })
      }
      case 5: {
        const newItems = orderBy(myInbox, 'nick_name', sort_order)
        return this.setState({ items: newItems })
      }
      case 6: {
        const newItems = orderBy(myInbox, 'position', sort_order)
        return this.setState({ items: newItems })
      }
      case 7: {
        const newItems = orderBy(myInbox, 'leave_type', sort_order)
        return this.setState({ items: newItems })
      }
      case 8: {
        const newItems = orderBy(myInbox, 'default_end_date', sort_order)
        return this.setState({ items: newItems })
      }
      default: return myInbox
    }
  }

  selectColor = (status) => {
    if (status === 'PENDING' || status === 'PENDING_HR') return '#FFD27C'
    else if (status === 'APPROVED') return '#5CB85C'
    else if (status === 'REJECTED') return '#D9534F'
    return '#CCCCCC'
  }

  renderItem = (index) => {
    const d = this.state.items[index]
    return (
      <tr
        key={ shortid() }
        style={ { hover: '#E5E5E5' } }
        onClick={ () =>
          this.props.handleClickRow(d._id, d.type, d.leave_type, d.project_id) }
      >
        <td style={ { color: this.selectColor(d.status) } }>
          <Circle status={ d.status } /> { d.status }
        </td>
        <td>{ d.start_date }</td>
        <td>{ d.end_date }</td>
        <td>{ d.emp_code }</td>
        <td>{ d.lob }</td>
        <td>{ d.name }</td>
        <td>{ d.nick_name }</td>
        <td>{ d.position }</td>
        <td>{ d.leave_type || d.type}</td>
      </tr>
    )
  }

  render() {
    const { sort_order, sort_column, items } = this.state
    return (
    /* eslint no-underscore-dangle: 0 */
      <TableDiv>
        <CustomTable bordered hover>
          <Header>
            <tr>
              {
                inbox_table_header.map((h) =>
                  (<HeadTable key={ shortid() } onClick={ () => this.handleClickSort(h.value) }>
                    { h.label }
                    { h.value === sort_column && (
                      sort_order && h.value === sort_column ?
                        <Icon src={ arrow_up } alt="logo" />
                        :
                        <Icon src={ arrow_down } alt="logo" />
                    )
                    }
                  </HeadTable>)
                )}
            </tr>
          </Header>
          <BodyTable>
            <ReactList
              itemRenderer={ this.renderItem }
              length={ items.length }
            />
          </BodyTable>
        </CustomTable>
      </TableDiv>
    )
  }
}

LeaveTypeTable.propTypes = {
  handleClickRow: PropTypes.func.isRequired,
}

const CustomTable = styled(Table)`
  font-size: ${FONTS.SMALL_SIZE};
  background: white;
  thead, tbody tr{
    display:table;
    width:100%;
    table-layout: fixed;
    font-family: ${FONTS.GOTHAM} !important;
  }
  @media (max-width: 575.98px) {
    max-width:1000px;
    thead, tbody tr{
      display:table;
      width:1000px;
      table-layout:fixed;
      font-family: ${FONTS.GOTHAM} !important;
    }
    td {
      padding-left: 1%;
    }
    th {
      padding-left: 1% ;
    }
  }
  @media (max-width: 767.98px) {
    max-width:1000px;
    thead, tbody tr{
      display:table;
      width:1000px;
      table-layout:fixed;
      font-family: ${FONTS.GOTHAM} !important;
    }
    td {
      padding-left: 1%;
    }
    th {
      padding-left: 1% ;
    }
  }
  @media (max-width: 991.98px) {
    max-width:1000px;
    thead, tbody tr{
      display:table;
      width:1000px;
      table-layout:fixed;
      font-family: ${FONTS.GOTHAM} !important;
    }
    td {
      padding-left: 1%;
    }
    th {
      padding-left: 1% ;
    }
  }
`
const HeadTable = styled.th`
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  cursor: pointer;
  @media (max-width: 575.98px) {
    font-size: 12px;
  }
  @media (max-width: 767.98px) {
    font-size: 12px;
  }
`
const BodyTable = styled.tbody`
  @media (max-width: 575.98px) {
    max-height: calc(100vh - 200px);
  }
  @media (max-width: 767.98px) {
    max-height: calc(100vh - 200px);
  }
  width: 100% ;
  display: block ;
  max-height: calc(100vh - 200px);
  overflow-y:scroll;
  overflow-x:hidden;
  ::-webkit-scrollbar {
    display: none;
  }
`
const TableDiv = styled.div`
  padding-bottom: 30px;
  padding-right: 10px;
  padding-left: 10px;
  @media (max-width: 575.98px) {
    padding-right: 0px;
    padding-left: 0px;
    font-size: 12px;
    width:100vw;
    overflow:scroll;
  }
  @media (max-width: 767.98px) {
    padding-right: 0px;
    padding-left: 0px;
    font-size: 12px;
    width:100vw;
    overflow:scroll;
  }
`
const Header = styled.thead`
  background: ${COLORS.TABLE_HEADER_COLOR};
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM};
`
const Circle = styled.div`
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  background-color: ${props => {
    const status = props.status
    if (status === 'PENDING' || status === 'PENDING_HR') {
      return '#FFD27C'
    } else if (status === 'APPROVED') {
      return '#5CB85C'
    } else if (status === 'REJECTED') {
      return '#D9534F'
    }
    return '#CCCCCC'
  }};
`
const Icon = styled.img`
  height: 10px;
  margin-left: 5%;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/components/table-inbox/index.js